/** back-endのエラーコード：ECR_RETRYのエラーが返ってきた時のコードを判別するために使用中 */
/** TODO BEエラーコードリファクタ時：MapView.vueと共に再修正必要 */
export const BACK_END_ERROR_CODES = {
  ECS_RETRY_2312: '402312'
} as const
